export const CHIP_FORM_CONSTANTS = {
  EMIT: {
    UPDATE_FORM_TEMPLATES: "update:formTemplates",
    REMOVE_FORM: "removeForm"
  }
};
